import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function HeroSection() {
  return <header className="relative bg-brand-sand overflow-hidden pt-20 pb-16 lg:pt-32 lg:pb-24 px-6" data-id="element-80">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-81">
        <motion.div className="text-center lg:text-left z-10" initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-82">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-brand-brown leading-tight mb-6" data-id="element-83">
            Menopausia Sin Tabú: <br data-id="element-84" />
            <span className="text-brand-terracotta" data-id="element-85">
              El Protocolo de 7 Días para Recuperar tu Vida
            </span>
          </h1>
          <h2 className="font-sans text-lg md:text-xl text-brand-brown/80 mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-86">
            Cómo eliminar los sofocos, el insomnio y la neblina mental en una
            semana (sin hormonas y usando ingredientes de tu supermercado en EE.
            UU.)
          </h2>

          <CtaButton onClick={() => document.getElementById('offer')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-87">
            ¡QUIERO EMPEZAR MI PROTOCOLO DE 7 DÍAS YA!
          </CtaButton>

          <p className="mt-4 text-sm text-brand-brown/60 font-sans italic" data-id="element-88">
            Acceso inmediato. Pago 100% seguro.
          </p>
        </motion.div>

        <motion.div className="relative z-10 flex justify-center lg:justify-end" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-89">
          <div className="relative w-full max-w-md aspect-[3/4] rounded-3xl overflow-hidden shadow-2xl border-4 border-brand-surface" data-id="element-90">
            <img src="https://cdn.magicpatterns.com/uploads/kEhAaaNRPpREg6taY1LDW3/Menopausia_sin_Tabu_-_Image_1.png" alt="Menopausia Sin Tabú en tu teléfono" className="w-full h-full object-cover" data-id="element-91" />
            {/* Decorative elements */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-brand-amber rounded-full mix-blend-multiply filter blur-2xl opacity-50" data-id="element-92"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-brand-terracotta rounded-full mix-blend-multiply filter blur-2xl opacity-30" data-id="element-93"></div>
          </div>
        </motion.div>
      </div>

      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-brand-surface/30 rounded-l-full blur-3xl -z-0 transform translate-x-1/3" data-id="element-94"></div>
    </header>;
}